import moment from 'moment';

/**
 * A service paid date is a calendar day, not an instant. It is stored as UTC
 * midnight of that day (e.g. 2026-09-10T00:00:00Z) regardless of the admin's
 * browser time zone.
 */

/**
 * Converts a stored paid date into a draft moment for the date picker: a
 * local-time moment at midnight of the stored UTC calendar day, so the picker
 * shows the same day no matter the browser's offset.
 */
export const paidDateToDraft = (paidDate: string | null | undefined): moment.Moment | null => {
    if (!paidDate) {
        return null;
    }

    return moment(moment.utc(paidDate).format('YYYY-MM-DD'), 'YYYY-MM-DD');
};

/**
 * Serialises a draft moment from the date picker as UTC midnight of the
 * calendar day it displays. Uses the draft's own calendar fields rather than
 * converting the instant, so local midnight never shifts to the previous day.
 */
export const draftToPaidDate = (draft: moment.Moment | null): string | null => {
    if (!draft) {
        return null;
    }

    return moment.utc(draft.format('YYYY-MM-DD'), 'YYYY-MM-DD').format();
};
